export const pmt = ({
  rate,
  nper,
  pv,
  fv = 0,
  type = 0,
}: {
  rate: number;
  nper: number;
  pv: number;
  fv?: number;
  type?: number;
}) => {
  /*
   * rate   - interest rate per month
   * nper   - number of periods (months)
   * pv   - present value
   * fv   - future value
   * type - when the payments are due:
   *        0: end of the period, e.g. end of month (default)
   *        1: beginning of period
   *
   * https://stackoverflow.com/questions/5294074/pmt-function-in-javascript
   * Ps. maybe calc rabatt as advance payments?
   */
  let pmt: number, pvif: number;

  if (rate === 0) return -(pv + fv) / nper;

  pvif = Math.pow(1 + rate, nper);
  pmt = (-rate * (pv * pvif + fv)) / (pvif - 1);

  if (type === 1) pmt /= 1 + rate;
  return Math.round(pmt);
};

export const percentToDecimal = (t: number) => {
  return t / 100;
};

export const yearlyToMonthlyCost = (cost: number) => {
  return cost / 12;
};

export const inclMomsToExMoms = (price: number) => {
  return price / 1.25;
};
